module.exports = ($scope, $stateParams, entities, RiskScore) ->
  $scope.getCurrentPage = (offset, limit) ->
    if offset and limit
      offset / limit + 1
    else
      1

  $scope.loadData = (params) ->
    $scope.loading = true
    entities(params).then (entities) ->
      $scope.entities = entities
      $scope.loading = false

  $scope.loadPage = (page) ->
    $scope.page = page or $scope.page
    limit = 10
    offset = ($scope.page - 1) * limit
    $scope.loadData
      offset: offset
      limit: limit
      name: $scope.searchText

  $scope.loadData($stateParams)
  $scope.currentPage = $scope.getCurrentPage($stateParams.offset, $stateParams.limit)

  $scope.isCalculatingRiskScore = false

  $scope.riskScoreClass = (score) ->
    if score <= 34
      return "risk-score-low"
    else if score > 34 and score < 68
      return "risk-score-medium"
    else
      return "risk-score-high"

  $scope.calculateRiskScore = (entity) ->
    return if $scope.isCalculatingRiskScore

    $scope.isCalculatingRiskScore = true
    RiskScore.calculate(entity.id, (err, rs) ->
      if err.length is 0
        entity.risk_score = rs
        entity.risk_score_error = ""
        if rs is -1
          entity.risk_score_error = "Not enough information"
      else
        entity.risk_score_error = err
      $scope.isCalculatingRiskScore = false
    )
